<template>
    <v-row>
        <v-col cols="12" sm="4" md="3">
            <v-select
                v-model="selectedCompanyId"
                :items="companies"
                item-text="razonSocial"
                item-value="id"
                label="Empresa"
                clearable
                @change="onCompanyChange"
            />
        </v-col>
        <v-col cols="12" sm="4" md="3" offset-md="6">
            <search-input @search="performSearch" v-model="search" />
        </v-col>

        <v-col cols="12">
            <v-data-table
                :headers="headers"
                :items="enrichedItems"
                :loading="loading"
                :server-items-length="totalItems"
                :page.sync="pageNumber"
                :items-per-page.sync="itemsPerPage"
                :sort-by.sync="orderBy"
                :sort-desc.sync="orderDesc"
                :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
                class="mt-3"
                @update:page="fetch"
                @update:sort-by="fetch"
                @update:sort-desc="fetch"
                @update:items-per-page="fetch"
            >
                <template slot="no-data">
                    <div class="text-center grey--text py-4">Sin usuarios</div>
                </template>

                <template v-slot:item.company="{ item }">
                    {{ item.company ? item.company.razonSocial : '-' }}
                </template>

                <template v-slot:item.role="{ item }">
                    <v-chip v-if="item.role" small>{{ item.role.name }}</v-chip>
                    <span v-else class="grey--text caption">-</span>
                </template>

                <template v-slot:item.overrides="{ item }">
                    <v-chip v-if="item.hasOverrides" small color="orange" dark>
                        Personalizado
                    </v-chip>
                    <span v-else class="grey--text caption">Sin cambios</span>
                </template>

                <template v-slot:item.action="{ item }">
                    <v-btn icon x-small @click="openEdit(item)">
                        <v-icon color="primary">mdi-account-cog</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import UserProvider from '../../../providers/UserProvider'
import CompanyProvider from '../../../providers/CompanyProvider'
import UserPermissionProvider from '../../../providers/UserPermissionProvider'
import { SearchInput } from '@dracul/common-frontend'

export default {
    name: 'UserPermissionsList',
    components: { SearchInput },
    data() {
        return {
            items: [],
            totalItems: 0,
            loading: false,
            pageNumber: 1,
            itemsPerPage: 10,
            orderBy: 'username',
            orderDesc: false,
            search: '',
            selectedCompanyId: null,
            companies: [],
            // mapa userId → override doc (cargado en batch al cambiar empresa)
            overridesMap: {}
        }
    },
    computed: {
        headers() {
            return [
                { text: 'Usuario', value: 'username' },
                { text: 'Empresa', value: 'company', sortable: false },
                { text: 'Rol', value: 'role', sortable: false },
                { text: 'Permisos', value: 'overrides', sortable: false },
                { text: 'Acciones', value: 'action', sortable: false }
            ]
        },
        getOrderBy() {
            return Array.isArray(this.orderBy) ? this.orderBy[0] : this.orderBy
        },
        getOrderDesc() {
            return Array.isArray(this.orderDesc) ? this.orderDesc[0] : this.orderDesc
        },
        enrichedItems() {
            return this.items.map(user => {
                const override = this.overridesMap[user.id]
                const hasOverrides = override &&
                    ((override.additionalPermissions && override.additionalPermissions.length > 0) ||
                     (override.revokedPermissions && override.revokedPermissions.length > 0))
                return { ...user, hasOverrides: !!hasOverrides }
            })
        }
    },
    created() {
        this.loadCompanies()
        this.fetch()
    },
    methods: {
        loadCompanies() {
            CompanyProvider.fetchCompanies()
                .then(r => { this.companies = r.data.companyFetch || [] })
                .catch(err => console.error(err))
        },
        onCompanyChange() {
            this.pageNumber = 1
            this.overridesMap = {}
            this.fetch()
            // Cargar overrides en batch para la empresa seleccionada
            if (this.selectedCompanyId) {
                UserPermissionProvider.fetchByCompany(this.selectedCompanyId)
                    .then(r => {
                        const docs = r.data.adminUserPermissionFetchByCompany || []
                        const map = {}
                        docs.forEach(d => { map[d.userId] = d })
                        this.overridesMap = map
                    })
                    .catch(err => console.error('[UserPermissionsList] Error fetching overrides:', err))
            }
        },
        performSearch() {
            this.pageNumber = 1
            this.fetch()
        },
        fetch() {
            this.loading = true
            UserProvider.paginateUsers(
                this.selectedCompanyId,
                this.pageNumber,
                this.itemsPerPage,
                this.search,
                this.getOrderBy,
                this.getOrderDesc
            )
                .then(r => {
                    this.items = r.data.adminUserPaginate.users || []
                    this.totalItems = r.data.adminUserPaginate.totalItems || 0
                })
                .catch(err => console.error(err))
                .finally(() => this.loading = false)
        },
        openEdit(user) {
            const companyId = this.selectedCompanyId ||
                (user.company ? user.company.id : null)
            const companyName = user.company ? user.company.razonSocial :
                ((this.companies.find(c => c.id === companyId) || {}).razonSocial || '')
            this.$emit('edit', {
                userId: user.id,
                companyId: companyId,
                userName: user.username,
                companyName: companyName,
                roleId: user.role ? user.role.id : null,
                roleName: user.role ? user.role.name : null
            })
        }
    }
}
</script>
